import React, { Component } from 'react'
import {
  Modal,
  Row,
  Col,
  Button,
  Badge,
  Tabs,
  Tab,
  Alert
} from 'react-bootstrap'
import moment from 'moment'
import 'moment/locale/es'

class IngresoMinimoSaveStatus extends Component {
  renderTipoCupo (tipoCupo, turnoSinCupo, turnoDeSalida) {
    let label
    let alerta = false
    switch (true) {
      case (turnoSinCupo !== '' && turnoDeSalida === '' && tipoCupo === ''): label = 'SIN CUPO'; alerta = true; break
      case (turnoSinCupo === '' && turnoDeSalida !== '' && tipoCupo === 'N'): label = 'NOMINADO'; break
      case (turnoSinCupo !== '' && turnoDeSalida === '' && tipoCupo === 'N'): label = 'NOMINADO'; alerta = true; break
      case (turnoSinCupo === '' && turnoDeSalida !== '' && tipoCupo === 'L'): label = 'LIBRE'; break
      case (turnoSinCupo !== '' && turnoDeSalida === '' && tipoCupo === 'L'): label = 'LIBRE'; alerta = true; break
      default:
        label = 'SIN CUPO'
        alerta = true
    }
    return (<h2><Badge variant={(alerta) ? 'danger' : 'success'}>{label}</Badge></h2>)
  };

  renderEstadoCupo (turnoDeSalida, codigoCupo, cpRechazo) {
    let estado
    let alerta = true
    let msj
    const msjrechazo = 'Ingresa como sustitución por el rechazo de la CP N° '
    switch (true) {
      case (turnoDeSalida !== '' && codigoCupo !== ''): estado = 'AUTORIZADO'; alerta = false; msj = 'La CP ingresa con Cupo Autorizado.'; break
      case (turnoDeSalida === '' && codigoCupo !== ''): estado = 'AUTORIZADO'; alerta = false; msj = 'La CP ingresa Autorizada por ARCA pero al momento no tiene Cupo.'; break
      case (codigoCupo === ''): estado = 'SIN AUTORIZACION'; msj = 'La CP ingresa sin Cupo y sin autorización de ARCA.'; break
      default:
        estado = 'SIN AUTORIZACION'
    }
    return (
      <div>
        <h1><Badge variant={(alerta) ? 'danger' : 'success'}>{estado}</Badge></h1>
        <Alert variant='warning'>
          <strong><h4>{msj}</h4></strong>
        </Alert>
        {cpRechazo !== '' && <Alert variant='info'>
          <strong><h4>{(cpRechazo !== '') ? msjrechazo.concat(cpRechazo) : ''}</h4></strong>
        </Alert>}
      </div>
    )
  };

  renderError (error, message = null) {
    return (
      <div className='iminimo-save-error'>
        <Row>
          <Col>
            <h3>Error : </h3>
            {error}
          </Col>
        </Row>
        <Row>
          <Col>
            <br />
            {message}
          </Col>
        </Row>
      </div>
    )
  };

  renderStatusCupo (cupoStatus) {
    const cupoData = cupoStatus.substr(1, cupoStatus.length - 2).split(',')
    return (
      <div className='iminimo-save-status'>
        <Row>
          <Col>
            <Tabs defaultActiveKey={1} id='iminimo-status-tab'>
              <Tab eventKey={1} title='Tipo de Cupo: '>
                {this.renderTipoCupo(cupoData[1], cupoData[8], cupoData[0])}
              </Tab>
            </Tabs>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <Tabs defaultActiveKey={1} id='iminimo-status-tab'>
              <Tab eventKey={1} title='Estado: '>
                {this.renderEstadoCupo(cupoData[0], cupoData[7], cupoData[9])}
              </Tab>
            </Tabs>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            <Tabs defaultActiveKey={1} id='iminimo-status-tab'>
              <Tab eventKey={1} title='Turno de Salida: '>
                <h1><Badge variant='default'>{(cupoData[0] !== '') ? cupoData[0] : cupoData[8]}</Badge></h1>
              </Tab>
            </Tabs>
          </Col>
          {/* </Row>
        <hr />
        <Row> */}
          <Col>
            <Tabs defaultActiveKey={1} id='iminimo-status-tab'>
              <Tab eventKey={1} title='Fecha de Cupo: '>
                <h1><Badge variant='default'>{cupoData[2]}</Badge></h1>
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </div>
    )
  };

  render () {
    const {
      onSubmit,
      status,
      penalizacion,
      penalizacionAcoplado
    } = this.props

    if (!status) return null

    let {
      message,
      data: cupoStatus,
      error
    } = status

    let vencimiento
    if (penalizacion && penalizacion.vencimientoPenalizacion) {
      vencimiento = moment(penalizacion.vencimientoPenalizacion).format('LLL')
    }

    let vencimientoAcoplado
    if (penalizacionAcoplado && penalizacionAcoplado.vencimientoPenalizacionAcoplado) {
      vencimientoAcoplado = moment(penalizacionAcoplado.vencimientoPenalizacionAcoplado).format('LLL')
    }

    cupoStatus = cupoStatus.length > 0
      ? cupoStatus[0].cartaDePorteAutomotorIngresoInsert : null
    return (
      <div>
        <Modal show style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Modal.Header>
            <h3>Información del ingreso</h3>
          </Modal.Header>
          <Modal.Body>
            {cupoStatus && this.renderStatusCupo(cupoStatus)}
            {error && this.renderError(null, message)}
          </Modal.Body>
          {(penalizacion || penalizacionAcoplado) && <Alert variant='dark' style={{ width: '85%', margin: '0 auto', textAlign: 'center' }}>
            <h4>La patente{' '}
              {penalizacion && penalizacion.camionPenalizado && <strong>{penalizacion.camionPenalizado} </strong> }
              {penalizacionAcoplado && penalizacionAcoplado.camionPenalizado && <strong>{penalizacionAcoplado.acopladoPenalizado} </strong> }
                se encuentra penalizada por{' '}
              {penalizacion && penalizacion.camionPenalizado && <strong>{penalizacion.motivoPenalizacion} </strong> }
              {penalizacionAcoplado && penalizacionAcoplado.acopladoPenalizado && <strong>{penalizacionAcoplado.acopladoPenalizado} </strong> } .
            </h4>
            <h4>No podrá egresar de la playa hasta el{' '}
              {penalizacion && penalizacion.camionPenalizado && <strong>{vencimiento} </strong> }
              {penalizacionAcoplado && penalizacionAcoplado.acopladoPenalizado && <strong>{vencimientoAcoplado} </strong> } hs.
            </h4>
          </Alert> }
          <Modal.Footer>
            <Button onClick={() => onSubmit()} variant='primary'>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  };
};

export default IngresoMinimoSaveStatus
